import { createSlice, nanoid, current } from "@reduxjs/toolkit";

const shoppingCartSlice = createSlice({
  name: "shoppingCart",
  initialState: [],
  reducers: {
    addProduct(state, action) {
      let itemInCart = state.find((item) => item.id === action.payload.id);

      return itemInCart
        ? state.map((product) =>
            product.id === action.payload.id
              ? { ...product, quantity: product.quantity + 1 }
              : product
          )
        : [...state, { ...action.payload, quantity: 1 }];
    },
    addQuantity(state, action) {
      state.map((item) =>
        item.id === action.payload ? item.quantity++ : item
      );
    },
    deleteProduct(state, action) {
      const product = state.find((item) => item.id === action.payload);

      if (product.quantity > 1) {
        state.map((item) =>
          item.id === action.payload ? item.quantity-- : item
        );
      } else {
        return state.filter((product) => product.id !== action.payload);
      }
    },
    deleteAllProduct(state, action) {
      return state.filter((product) => product.id !== action.payload);
    },
    removeCart(state, action) {
      return [];
    },
  },
});
const { actions, reducer } = shoppingCartSlice;

export const {
  addProduct,
  deleteProduct,
  deleteAllProduct,
  addQuantity,
  removeCart,
} = actions;

export default reducer;
